/**
 * TODO: Try to resize body to min-height of
 */

import React, { useEffect, useState } from 'react';

import styled from '@emotion/styled';

import { classNames } from '../../services/classNames';
import { CookieBar } from '../CookieBar';
import { Footer } from '../Footer';
import { MainHeader } from '../MainHeader';

export const MainLayout: React.FC<any> = ({
    className,
    children,
    hideFooter = false,
    calculateMinHeight = false,
}) => {
    const [headerHeight, setHeaderHeight] = useState(0);
    const [footerHeight, setFooterHeight] = useState(0);
    const [headerAndFooterHeight, setHeaderAndFooterHeight] = useState(0);

    useEffect(() => {
        setHeaderAndFooterHeight(headerHeight + footerHeight);
    }, [headerHeight, footerHeight]);

    return (
        <>
            <MainHeader setHeight={setHeaderHeight} />
            <Main
                className={classNames(
                    'MainLayout',
                    hideFooter && 'MainLayout--hidden-footer',
                    className,
                )}
                calculateMinHeight={calculateMinHeight}
                headerAndFooterHeight={headerAndFooterHeight}
            >
                {children}
            </Main>
            {!hideFooter && <Footer setHeight={setFooterHeight} />}
            <CookieBar />
        </>
    );
};

const Main = styled.main<{
    calculateMinHeight: boolean;
    headerAndFooterHeight: number;
}>`
    ${(props) =>
        props.calculateMinHeight &&
        `
        min-height: calc(100vh - ${props.headerAndFooterHeight}px)
    `}
`;
